import styled from 'styled-components/native';
import { hpx } from '../../../styles';

export const Container = styled.View`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  margin-bottom: 10px;
  background-color: #fff;
`;

export const PriceRadio = styled.View`
  background-color: ${props =>
    props.selected ? props.theme.colors.primary : 'transparent'};
  border: 1.5px solid ${props => props.selected ? props.theme.colors.primary : '#ccc'};
  width: ${hpx(22)};
  height: ${hpx(22)};
  border-radius: ${hpx(11)};
`;

export const Label = styled.Text`
  font-size: 16px;
  color: #333;
`;
